import { render, staticRenderFns } from "./RevealBlock.vue?vue&type=template&id=7ddad778"
import script from "./RevealBlock.vue?vue&type=script&lang=js"
export * from "./RevealBlock.vue?vue&type=script&lang=js"
import style0 from "./RevealBlock.vue?vue&type=style&index=0&id=7ddad778&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports